/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Modal, OrderedList, ListItem } from 'carbon-components-react';
import React from 'react';

import { Noop } from '../../../../ts';

const strings = {
  MODAL_LABEL: 'Upgrade',
  MODAL_HEADING: "First we'll need some payment information",
  PLUS_UPGRADE_STEP_1:
    "To begin, we'll take you to the IBM Cloud payment portal.",
  PLUS_UPGRADE_STEP_2:
    'Add your payment info, and then relaunch watsonx Assistant.',
  PLUS_UPGRADE_STEP_3: 'Confirm that you want to upgrade to the Plus plan.',
  PLUS_UPGRADE_STEP_4: 'Continue building, now with greater capabilities.',
  BEGIN: 'Begin',
  CANCEL: 'Cancel'
};

export interface PlusStepsModalProps {
  onRequestClose: Noop;
  onRequestSubmit: Noop;
}
const PlusStepsModal: React.FC<PlusStepsModalProps> = ({
  onRequestClose,
  onRequestSubmit
}) => {
  const stepsList = [
    'PLUS_UPGRADE_STEP_1',
    'PLUS_UPGRADE_STEP_2',
    'PLUS_UPGRADE_STEP_3',
    'PLUS_UPGRADE_STEP_4'
  ];

  return (
    <Modal
      open
      size="sm"
      className="PlusStepsModal"
      modalLabel={strings.MODAL_LABEL}
      modalHeading={strings.MODAL_HEADING}
      preventCloseOnClickOutside
      primaryButtonText={strings.BEGIN}
      secondaryButtonText={strings.CANCEL}
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}>
      <div className="UpgradeModal__body">
        <OrderedList className="UpgradeModal__list">
          {stepsList.map(item => (
            <ListItem key={item}>{strings[item]}</ListItem>
          ))}
        </OrderedList>
      </div>
    </Modal>
  );
};

export default PlusStepsModal;
